import type { MouseEvent } from "react";
import { FaArrowDown } from "react-icons/fa6";

type Props = {
  size?: number;
  onRetry: () => void;
  className?: string;
};

/**
 * Telegram-style «download again» control over blur_hash after cancel.
 */
export default function TgMediaRetryButton({
  size = 44,
  onRetry,
  className = "",
}: Props) {
  const shell = size + 14;

  const handle = (e: MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    onRetry();
  };

  return (
    <div
      className={`absolute inset-0 z-[2] grid place-content-center ${className}`}
    >
      <button
        type="button"
        aria-label="Скачать снова"
        onClick={handle}
        className="grid place-content-center rounded-full bg-black/45 text-white shadow-sm backdrop-blur-[1px] transition-colors hover:bg-black/55"
        style={{ width: shell, height: shell }}
      >
        <FaArrowDown className={size >= 40 ? "h-4 w-4" : "h-3.5 w-3.5"} />
      </button>
    </div>
  );
}
